// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3lvF7","content":"ManualTimeModal_content__3jGG4"};